import { createClient } from "@supabase/supabase-js";
import { removeSpecialCharacters } from "../helpers/removeSpecialCharacters";
import api from "./api";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
const supabase = createClient(supabaseUrl as string, supabaseKey as string);

const controller = "clientes";

export const getAllClientes = () => api.get<any>(`api/${controller}`);

export const postCreateClientes = async (values: any) => {
  let formData = new FormData();

  // Anexe o arquivo ao FormData
  if (values.files) {
    if (values.files.length > 0) {
      values.files.forEach((file: any) => {
        const sanitizedFileName = removeSpecialCharacters(file.originFileObj.name);
        formData.append(
          "files",
          new File([file.originFileObj], sanitizedFileName, {
            type: file.originFileObj.type,
          })
        );
      });
    }
  }

  // Anexando os campos do formulário ao FormData
  formData.append("nome", values.nome);
  formData.append("endereco", values.endereco);
  formData.append("rg", values.rg);
  formData.append("cpf", values.cpf);
  if (values.email !== null) {
    formData.append("email", values.email);
  }
  formData.append("telefone", values.telefone);
  formData.append("nacionalidade", values.nacionalidade);
  formData.append("estado_civil", values.estado_civil);
  formData.append("anotacoes", values.anotacoes);
  formData.append("created_by", values.userId);
  formData.append("statusClienteId", values.statusClienteId);

  // Anexando a matriz de ações ao FormData
  if (values.acoes && values.acoes.length > 0) {
    values.acoes.forEach((acao: string) => {
      formData.append("acoes", acao);
    });
  }

  const config = {
    headers: { "content-type": "multipart/form-data" },
  };

  const response = await api
    .post<any>(`api/${controller}`, formData, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Erro na solicitação:", error);
      return error;
    });

  return response;
  // if (response.status === 200) {} else {}
};

export const getClientesById = (id: string) =>
  api.post<any>(`api/${controller}/getClientes`, { id });

export const getAnexosByClientesId = (id: string) =>
  api.post<any>(`api/${controller}/getAnexosByClienteId`, { id });

export const editClientesById = async (values: any) => {
  let formData = new FormData();
  // Anexe o arquivo ao FormData
  if (values.files) {
    if (values.files.length > 0) {
      values.files.forEach((file: any) => {
        const sanitizedFileName = removeSpecialCharacters(file.originFileObj.name);
        formData.append(
          "files",
          new File([file.originFileObj], sanitizedFileName, {
            type: file.originFileObj.type,
          })
        );
      });
    }
  }

  // Anexando os campos do formulário ao FormData
  formData.append("id", values.id);
  formData.append("nome", values.nome);
  formData.append("endereco", values.endereco);
  formData.append("rg", values.rg);
  formData.append("cpf", values.cpf);
  formData.append("email", values.email);
  formData.append("telefone", values.telefone);
  formData.append("nacionalidade", values.nacionalidade);
  formData.append("estado_civil", values.estado_civil);
  formData.append("anotacoes", values.anotacoes);
  formData.append("statusClienteId", values.statusClienteId);

  // Anexando a matriz de ações ao FormData
  if (values.acoes && values.acoes.length > 0) {
    values.acoes.forEach((acao: any) => {
      formData.append("acoes", typeof acao === "string" ? acao : acao.value);
    });
  }

  const config = {
    headers: { "content-type": "multipart/form-data" },
  };

  const response = await api
    .put<any>(`api/${controller}`, formData, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Erro na solicitação:", error);
      return error;
    });

  return response;
};

export const deleteClientesById = (id: string) =>
  api.delete<any>(`api/${controller}/delete/${id}`);

export const deleteAnexoClientesById = async (values: any) => {
  return await api.post<any>(`api/${controller}/deleteAnexo`, values);
};

export const downloadClienteAnexo = async (values: any) => {
  // const response = await api.get<any>(
  //   `api/${controller}/downloadAnexo/${values.id}`
  // );
  const idCliente = values.idCliente;
  const nomeArquivo = values.file_name;
  const { data, error } = await supabase.storage
    .from("ClienteBucketFiles")
    .download(`clientes/${idCliente}/${nomeArquivo}`);

  if (error) {
    throw error;
  }
  return data;
};

export const gerarRelatorioDeClientes = async (values: any) => {
  return await api.post<any>(
    `api/${controller}/gerarRelatorioDeClientes`,
    values,
    {
      responseType: "blob",
    }
  );
};
